import React from 'react';
import { FAILURE_LOGO_PATH } from '../../../constants/logo';

interface Props {
  onClose: () => void;
  tryAgain: () => void;
  message?: string;
}

const FailedPopup: React.FC<Props> = ({
  onClose,
  tryAgain,
  message = "Sorry, the payment wasn't successfully linked. Please try again."
}) => {
  return (
    <div className="failed">
      <img src={FAILURE_LOGO_PATH} className="mx-auto h-32" alt="" />

      <h5 className="my-2 pb-0 text-center text-xl font-semibold text-red-500">
        Failed
      </h5>
      <p className="text-wrap px-10 text-center font-semibold">{message}</p>

      <div className="text-center">
        <button
          className="mx-1 my-5 rounded-full border-2 border-solid border-green-800 px-5 py-2 text-base font-medium text-green-800 shadow-sm focus:outline-none focus:ring-offset-2"
          onClick={onClose}
        >
          Maybe Later
        </button>

        <button
          className="mx-1 my-5 rounded-full bg-green-800 px-10 py-2 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-offset-2"
          onClick={tryAgain}
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default FailedPopup;
